<template>
  <div class="invitation">
    <div class="invitation__intro">{{ content.data.invitation.header }}</div>
    <AmountSelect @minus="minus" @plus="plus" :value="value" />
    <div
      class="btnS invitation__cta"
      :class="{ disabled: value < 30 }"
      id="invitation__cta"
      @click="open"
    >
      Wspieram
    </div>
    <div class="invitation__box">
      <div class="invitation__subtitle">{{ content.data.invitation.intro }}</div>

      <div
        v-for="item in content.data.invitation.content"
        :key="item"
        class="invitation__item"
      >
        <div class="invitation__check">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.3 19">
            <g id="Warstwa_2" data-name="Warstwa 2">
              <g id="Warstwa_1-2" data-name="Warstwa 1">
                <path
                  d="M8.7,14,2.8,8.1a.6.6,0,0,0-.8,0L.2,9.9c-.3.3-.3.6,0,.8L6,16.6l2.2,2.2a.7.7,0,0,0,.9,0l2.2-2.2L25.1,2.8a.6.6,0,0,0,0-.8L23.3.2a.5.5,0,0,0-.8,0Z"
                  fill="#ff6436"
                />
              </g>
            </g>
          </svg>
        </div>
        <div class="invitation__info">
          {{ item }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AmountSelect from "./AmountSelect.vue";
export default {
  props: ["value"],
  methods: {
    minus() {
      this.$emit("minus");
    },
    plus() {
      this.$emit("plus");
    },
    open() {
      this.$emit("open");
      this.$root.$emit("toggleModalInvitation", false);
      this.$root.$emit("toggleModalPayment", true);
    },
  },
  inject: ["content", "appData"],
  name: "Invitation",
  components: { AmountSelect },
};
</script>
